import React, {
  createContext,
  useState,
  useContext,
  Dispatch,
  SetStateAction,
} from "react";

// Define the context type, allow `formType` to be `string | undefined`
interface IFormTypeContext {
  formType: string | undefined;
  setFormType: Dispatch<SetStateAction<string | undefined>>; // Updated to allow `undefined`
}

// Create the context
const FormTypeContext = createContext<IFormTypeContext | undefined>(undefined);

// Provider component
export const FormTypeProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [formType, setFormType] = useState<string | undefined>(undefined); // `formType` can be `string | undefined`

  return (
    <FormTypeContext.Provider value={{ formType, setFormType }}>
      {children}
    </FormTypeContext.Provider>
  );
};

// Custom hook to access the context
export const useFormType = () => {
  const context = useContext(FormTypeContext);
  if (!context) {
    throw new Error("useFormType must be used within a FormTypeProvider");
  }
  return context;
};
